import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import StockService from '../../../../services/StockService';
import { formatDateToPtbr, translate } from '../../../../utils/util';
import { Breadcrumbs } from '../../../../components/UI/ComponentsUI';
import ListUI from '../../../../components/UI/ListUI';

const LowHoursList = (props) => {
    const [lowHours, setLowHours] = useState([]);

    useEffect(() => {
        getlowHours();
        // eslint-disable-next-line
    }, []);

    const getlowHours = () => {
        props.getScheduleDiffusionPaged({
            PageSize: 20,
        }, (data) => {
            setLowHours(data)
        })
    }

    const redirect = () => {
        props.history.push({ pathname: './insert' })
    }

    const onDelete = (item) => {
        props.deleteScheduleDiffusion(item.id, () => {
            getlowHours();
        })
    }

    return (
        <div>
            <Breadcrumbs title={{ icon: "mdi mdi-file-document-multiple", label: translate('stock:low-hours') }} />
            <i className={`mdi mdi-36px mdi-sticker-plus above-btn`} style={{ cursor: 'pointer' }} onClick={() => redirect()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div id="listcim">
                    <ListUI
                        data={lowHours.map((item) => (
                            <>
                                <span
                                    className="title sixth-text-color right"
                                    style={{ position: 'absolute', marginTop: '50px', right: '13px' }}
                                >
                                    <i className="material-icons small sixth-text-color"
                                        onClick={() => onDelete(item)}
                                        style={{ cursor: 'pointer' }}>delete</i>
                                </span>
                                <div
                                    id={item.id}
                                    style={{ backgroundColor: 'white', color: 'black', display: 'block', padding: '10px' }}
                                >
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="title black-text col s12" style={{ padding: '0px', paddingLeft: '0px' }}>
                                            Hora: {item.time}
                                        </div>
                                    </div>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="col s12" style={{ padding: '0px' }}>
                                            <small>{`Criado Por: ${item.createdBy} ${item.createdByDesc} `}</small>
                                        </div>
                                        <div className="col s12" style={{ padding: '0px' }}>
                                            <small>{`Data Criação: ${(formatDateToPtbr(item.createdOn))} `}</small>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        lowHours: state.stockReducer.lowHours,
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getScheduleDiffusionPaged: (filter, callback) => {
            dispatch(StockService.getScheduleDiffusionPaged(filter, callback));
        },
        deleteScheduleDiffusion: (id, callback) => {
            dispatch(StockService.deleteScheduleDiffusion(id, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LowHoursList)));
